import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import SaveIcon from '@mui/icons-material/Save';
// import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Header from './Header';
import { apiBaseURL, apiURL, apiKey } from '../../constant';
import Swal from "sweetalert2";

const AddSubTopic = () => {
    const navigate = useNavigate();
    const [topics, setTopics] = useState([]);
    const [subtopics, setsubTopics] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showSubTopicForm, setShowSubTopicForm] = useState(false);
    useEffect(() => {
        fetchTopics();
        fetchSubTopics();
    }, []);
    // ----------------------------------Fetch Topics---------------------------------------------------//
    const fetchTopics = async () => {
        try {
            const response = await fetch(apiBaseURL + apiURL.showTopics, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "key": apiKey
                }
            });
            const result = await response.json();
            if (result.status === 1) {
                setTopics(result.data);
                console.log(result);
            } else {
                setTopics([]);
            }
        } catch (error) {
            console.error("Error fetching topics:", error);
            setTopics([]);
        } finally {
            setLoading(false);
        }

    };
    // ----------------------------------End---------------------------------------------------//
    // ----------------------------------Fetch Sub Topics---------------------------------------------------//
    const fetchSubTopics = async () => {
        try {
            const response = await fetch(apiBaseURL + apiURL.showSubTopics, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "key": apiKey
                }
            });
            const result = await response.json();
            if (result.status === 1) {
                setsubTopics(result.data);
                console.log(result);
            } else {
                setsubTopics([]);
            }
        } catch (error) {
            console.error("Error fetching topics:", error);
            setsubTopics([]);
        } finally {
            setLoading(false);
        }

    };
    // ----------------------------------End---------------------------------------------------//
    // ----------------------------------Submit Handle---------------------------------------------------//
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const [formData, setFormData] = useState({
        mainTopicID: '',
        subTopicDesc: '',
    });
    const handleSubmit = async (e) => {
        e.preventDefault();
        const { mainTopicID, subTopicDesc } = formData;
        const data = {
            mainTopicID, subTopicDesc
        };
        console.log("API Data:", data);
        try {
            const url = apiBaseURL + apiURL.saveSubTopic;
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "key": apiKey
                },
                body: JSON.stringify(data)
            });
            const result = await response.json();
            console.log("API Response:", result);
            if (result.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: result.message,
                    confirmButtonText: "OK",
                });
                handleReset();
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops! ",
                    text: result.message,
                    confirmButtonText: "OK",
                });
            }

        }
        catch (error) {
            console.error("API Error:", error);
            Swal.fire({
                icon: "error",
                title: "Something went wrong!",
                text: "Please try again. To add new topic.",
                confirmButtonText: "OK",
            });
        }
        setTimeout(() => {
            window.location.reload();
        }, 2000);
    }
    const handleReset = () => {
        setFormData({
            mainTopicID: '',
            subTopicDesc: '',
        });
    };

    // ----------------------------------Submit Handle---------------------------------------------------//
    // ----------------------------------Submit Search---------------------------------------------------//
    const [searchData, setSearchData] = useState({
        mainTopicID: ""
    });
    const handleSearchChange = (e) => {
        const { name, value } = e.target;
        setSearchData(prev => ({
            ...prev,
            [name]: value
        }));
    };
    const handleSearch = async (e) => {
        e.preventDefault();

        const topicID = searchData.mainTopicID;

        if (!topicID) {
            console.log("Please select a topic first");
            return;
        }

        try {
            const response = await fetch(
                apiBaseURL + apiURL.searchSubTopics,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "key": apiKey
                    },
                    body: JSON.stringify({
                        mainTopicID: searchData.mainTopicID
                    })
                }
            );

            const result = await response.json();

            console.log("HTTP Status:", response.status);
            console.log("API Response:", result);

            if (response.ok && result.status === 1) {
                setsubTopics(result.data || []);
            } else {
                setsubTopics([]);
                console.log("Error:", result.message);
                console.log("Validation Errors:", result.errors);
            }

        } catch (error) {
            console.error("API Error:", error);
            setsubTopics([]);
        }
    };
    // ----------------------------------Submit Search---------------------------------------------------//
    // ---------------------------------Handle Remove--------------------------------------------------//
    const handleRemove = async (subTopicID) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to remove this record!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Yes, Remove",
            cancelButtonText: "Cancel"
        });

        if (!result.isConfirmed) {
            return;
        }

        try {
            const response = await fetch(apiBaseURL + apiURL.deleteSubTopic, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "key": apiKey
                },
                body: JSON.stringify({
                    subTopicID: subTopicID
                })
            });

            const result = await response.json();
            if (response.ok && result.status === 1) {
                // alert("Record removed successfully!");
                setsubTopics(prev =>
                    prev.filter(item => item.subTopicID !== subTopicID)
                );
                Swal.fire({
                    title: "Removed!",
                    text: result.message,
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false
                });
            } else {
                // alert(response.message || "Unable to remove record");
                Swal.fire({
                    title: "Error!",
                    text: '',
                    icon: "Unable to remove record.",
                    timer: 2000,
                    showConfirmButton: false
                });
            }
        } catch (error) {
            console.error("Error:", error);
            // alert("Something went wrong!");
            Swal.fire({
                title: "Error!",
                text: '',
                icon: "Something went wrong!",
                timer: 2000,
                showConfirmButton: false
            });
        }
    };
    // ---------------------------------Handle Remove--------------------------------------------------//

    return (
        <>
            <Header />
            <div className="container-fluid px-3 px-md-4 py-3">
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-3" style={{ borderBottom: '1px solid #dee2e6', paddingBottom: '12px' }}>
                    <div><h4 className="mb-1">Add Sub Topic</h4><small className="text-muted">Add a new sub topic for the following topic</small></div>
                    <button type="button" className="btn btn-outline-secondary mt-2 mt-md-0" onClick={() => navigate(-1)}><ArrowBackIcon style={{ fontSize: '18px', marginRight: '5px' }} />Back</button>

                </div>
                <div className="card shadow-sm">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-10 mb-3">

                            </div>
                            <div className="col-md-2 mb-3">
                                <button type="button" className="btn btn-success btn-md pull-right" onClick={() => setShowSubTopicForm(prev => !prev)}><i className='fa fa-plus' style={{ fontSize: '18px', marginRight: '5px' }} > </i> Add Sub Topic
                                </button>

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <form onSubmit={handleSubmit} id='addsubTopicForm' style={{ display: showSubTopicForm ? 'block' : 'none' }}>
                                    <div className="row">
                                        <div className="col-md-3 mt-3">
                                            <label className="form-label">Select Topic <span className="text-danger">*</span></label>
                                            <select className="form-control" name="mainTopicID" value={formData.mainTopicID || ""} onChange={handleChange} required>
                                                <option value="">~Select~</option>
                                                {topics.length > 0 && topics.map((topic, index) => (
                                                    <option key={topic.questionCatID || index} value={topic.questionCatID}>
                                                        {index + 1}: {topic.questionCatDesc}
                                                    </option>
                                                ))
                                                }
                                            </select>
                                        </div>
                                        <div className="col-md-9 mt-3">
                                            <label className="form-label">Sub Topic Name <span className="text-danger">*</span></label>
                                            <input type='text' className='form-control' name='subTopicDesc' value={formData.subTopicDesc} onChange={handleChange} required />
                                        </div>

                                    </div>
                                    <br></br>
                                    <button type='submit' className="btn btn-sm btn-success">Save <i className="fa fa-save"></i></button>&nbsp;
                                    <button type='reset' className="btn btn-sm btn-primary">Reset <i className="fa fa-refresh"></i></button>
                                </form>
                                <br></br>
                                <div className='chapterData' style={{ "font-size": "15px", "height": "60vh", "overflow-y": "scroll", "overflow-x": "hidden" }} id='data-table'>
                                    <form onSubmit={handleSearch} id='searchForm'>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <select
                                                    className="form-control"
                                                    name="mainTopicID"
                                                    value={searchData.mainTopicID}
                                                    onChange={handleSearchChange}
                                                >
                                                    <option value="">~Select Topic~</option>

                                                    {topics.map((topic, index) => (
                                                        <option
                                                            key={topic.questionCatID || index}
                                                            value={topic.questionCatID}
                                                        >
                                                            {index + 1}: {topic.questionCatDesc}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-2">
                                                <button type="submit" className="btn btn-primary btn-md" >
                                                    <i className="fa fa-search"></i> Search
                                                </button>&nbsp;
                                                <button type="button" className="btn btn-warning btn-md" onClick={() => window.location.reload()} >
                                                    <i className="fa fa-refresh" style={{ fontSize: '16px', marginRight: '5px' }}></i> Refresh
                                                </button>
                                            </div>
                                        </div>
                                    </form>


                                    <table className="table table-bordered table-striped mt-1" style={{ "font-size": "15px" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ background: "#251e1e", color: "#fff" }}>S.N</th>
                                                <th style={{ background: "#251e1e", color: "#fff" }}>Sub Topic Name</th>
                                                <th style={{ background: "#251e1e", color: "#fff" }}>Topic Name</th>
                                                <th style={{ background: "#251e1e", color: "#fff" }}>Status</th>
                                                <th style={{ background: "#251e1e", color: "#fff" }}>Created On</th>
                                                <th style={{ background: "#251e1e", color: "#fff" }} className='text-center'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {subtopics.length > 0 ? (subtopics.map((subtopic, index) => (
                                                <tr key={subtopic.questionCatID}>
                                                    <td>{index + 1}</td>
                                                    <td style={{ width: "50%" }}>{subtopic.subTopicDesc ?? ''}</td>
                                                    <td>{subtopic.getTopic?.questionCatDesc ?? ''}</td>
                                                    <td><span className={`badge ${subtopic.status == 1 ? "text-success" : "text-danger"}`} style={{ "font-size": "14px" }}>
                                                        {subtopic.status == 1 ? "Active" : "Inactive"}
                                                    </span></td>
                                                    <td>{subtopic.createdDate
                                                        ? new Date(subtopic.createdDate).toLocaleString('en-IN', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true
                                                        })
                                                        : '-'
                                                    }</td>
                                                    <td className='text-center'>
                                                        <button className="btn btn-sm btn-danger" onClick={() => handleRemove(subtopic.subTopicID)}>
                                                            <i className="fa fa-close"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        {loading ? "Loading..." : "No data found."}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default AddSubTopic;
